import { ADD_UPDATE_TEMPLATE_SUCCESS, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATE_ERROR, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS, GET_ALL_PUBLIC_TEMPLATES_ERROR, GET_ALL_PUBLIC_TEMPLATES_SUCCESS, GET_TEMPLATES_SUCCESS, SHOW_TEMPLATES_MESSAGE, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR } from '../../appRedux/actions/templatesAction';
import _ from 'lodash';
import { DELETE_TEMPLATE_ERROR, DELETE_TEMPLATE_SUCCESS, GET_ALL_GROUP_TEMPLATES_ERROR, GET_ALL_GROUP_TEMPLATES_SUCCESS, ADD_UPDATE_GROUP_TEMPLATE_SUCCESS, GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS, DELETE_GROUP_TEMPLATE_SUCCESS, DELETE_GROUP_TEMPLATE_ERROR } from '../../appRedux/actions/templatesAction';
const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    templates: [],
    publicTemplates: [],
    categorizedPublicTemplates: null,
    categorizedGroupTemplates: null,
    groupTemplates: []
}

export default (state = INIT_STATE, action) => {
    let newState;
    let index;
    let templates;
    let groupTemplates;
    switch (action.type) {
        case GET_TEMPLATES_SUCCESS: {
            return {
                ...state,
                loader: false,
                templates: action.templates.sort((a, b) => a.name.localeCompare(b.name))
            }
        }

        case SHOW_TEMPLATES_MESSAGE: {
            return {
                ...state,
                alertMessage: action.message,
                showMessage: true,
                loader: false
            }
        }

        case ADD_UPDATE_TEMPLATE_SUCCESS: {

            newState = { ...state };
            templates = [...newState.templates];
            index = templates.findIndex(template => template.id === action.template.id);


            if (index !== -1) {
                templates[index] = { ...action.template };
            } else {
                templates.push({ ...action.template })
            }

            newState.templates = templates;
            return {
                ...newState,
            }
            // return {
            //     ...state,
            //     loader: false,
            //     templates: action.templates
            // }
        }

        case DELETE_TEMPLATE_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.templates = _.cloneDeep(action.templates)
            return newState;
        }

        case DELETE_TEMPLATE_ERROR: {
            newState = _.cloneDeep(state);
            newState.loader = false;
            return newState;
        }

        case GET_ALL_PUBLIC_TEMPLATES_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.publicTemplates = action.publicTemplates.length > 0 ? action.publicTemplates.sort((a, b) => a.name.localeCompare(b.name)) : [];
            return newState;
        }

        case GET_ALL_PUBLIC_TEMPLATES_ERROR: {
            return {
                ...state,
                loader: false,
            }
        }
        case GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.categorizedPublicTemplates = _.cloneDeep(action.categorizedPublicTemplates);
            return newState;
        }

        case GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR: {
            return {
                ...state,
                loader: false,
            }
        }

        case GET_ALL_GROUP_TEMPLATES_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.groupTemplates = _.cloneDeep(action.groupTemplates);
            return newState;
        }


        case GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.categorizedGroupTemplates = _.cloneDeep(action.categorizedGroupTemplates);
            return newState;
        }

        case GET_ALL_GROUP_TEMPLATES_ERROR: {
            return {
                ...state,
                loader: false,
            }
        }

        case ADD_UPDATE_GROUP_TEMPLATE_SUCCESS: {

            newState = { ...state };
            groupTemplates = [...newState.groupTemplates];
            index = groupTemplates.findIndex(groupTemplate => groupTemplate.id === action.groupTemplate.id);


            if (index !== -1) {
                groupTemplates[index] = { ...action.groupTemplate };
            } else {
                groupTemplates.push({ ...action.groupTemplate })
            }

            newState.groupTemplates = groupTemplates;
            return {
                ...newState,
            }
        }

        case DELETE_GROUP_TEMPLATE_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.groupTemplates = _.cloneDeep(action.groupTemplates)
            return newState;
        }

        case DELETE_GROUP_TEMPLATE_ERROR: {
            newState = _.cloneDeep(state);
            newState.loader = false;
            return newState;
        }

        default:
            return state;
    }
}